<template>
    <div class="body v2-list-page">
        <div class="order-page-container">
            <div class="page-section">
                <a-card :bordered="false" style="width: 100%" class="v2-page-card">
                    <template slot="title">
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <router-link to="/cliente/monitores/cotacoes">
                                    Home
                                </router-link>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item class="order-page-title">
                                Meus Fornecedores
                            </a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <PageTabs :tabs="tabs" :active="activeTab" @change="openTab" />
                </a-card>
            </div>

            <div class="v2-tab-content">
                <ProvidersV2Tab
                    v-if="visitedTabs.includes('PROVIDERS')"
                    v-show="activeTab === 'PROVIDERS'"
                />
                <SellersV2Tab
                    v-if="visitedTabs.includes('SELLERS')"
                    v-show="activeTab === 'SELLERS'"
                    @count="(value) => (counts.SELLERS = value)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PageTabs from "@/components/cliente/monitors/PageTabs.vue";
import ProvidersV2Tab from "./tabs/providers-v2.tab.vue";
import SellersV2Tab from "./tabs/sellers-v2.tab.vue";

const TAB_KEYS = ["PROVIDERS", "SELLERS"];

const tabFromQuery = (query) => (TAB_KEYS.includes(query.tab) ? query.tab : "PROVIDERS");

export default {
    name: "SellersV2Page",
    components: { PageTabs, ProvidersV2Tab, SellersV2Tab },
    data() {
        const activeTab = tabFromQuery(this.$route.query);
        return {
            activeTab,
            visitedTabs: [activeTab],
            counts: { SELLERS: 0 },
        };
    },
    computed: {
        tabs() {
            return [
                { key: "PROVIDERS", label: "Fornecedores", icon: "local_shipping" },
                { key: "SELLERS", label: "Vendedores", icon: "storefront", badge: this.formatCount(this.counts.SELLERS) },
            ];
        },
    },
    watch: {
        "$route.query.tab"() {
            this.activate(tabFromQuery(this.$route.query));
        },
    },
    mounted() {
        this.$store.dispatch("set_breadcrumbs", [{ name: "Meus Fornecedores", route: "sellers-v2" }]);
    },
    methods: {
        formatCount(value) {
            return value ? Number(value).toLocaleString("pt-BR") : undefined;
        },
        activate(key) {
            this.activeTab = key;
            if (!this.visitedTabs.includes(key)) this.visitedTabs.push(key);
        },
        openTab(key) {
            this.activate(key);
            if (this.$route.query.tab !== key) {
                this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {});
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";
</style>
